import * as React from 'react';
import { createComponent } from '@lit/react';
import { SegmentedControlWC } from './segmented-control.wc';
import {
  GenerateComponentTypeWithChildren,
  GeneratePropsWithRef,
} from '../component-types-generics';

export type SegmentedControlProps =
  GenerateComponentTypeWithChildren<SegmentedControlWC> & {
    onChange?: (event: CustomEvent<{ value: string }>) => void;
  };

export type SegmentedControlPropsWithRef =
  GeneratePropsWithRef<SegmentedControlProps>;

export const SegmentedControl = createComponent({
  tagName: SegmentedControlWC.tagname,
  elementClass: SegmentedControlWC,
  react: React,
  events: {
    onChange: 'change',
  },
}) as SegmentedControlPropsWithRef;
